module.exports = __webpack_public_path__ + "img/L_313_0.88855c14.png";